export default {
    all: { method: 'GET', url: 'conta-receber' },
    active: { method: 'GET', url: 'conta-receber/active' },
    get: { method: 'GET', url: 'conta-receber/get{/id}' },
    create: { method: 'POST', url: 'conta-receber' },
    createConciliado: { method: 'POST', url: 'conta-receber/recebimento' },
    update: { method: 'PUT', url: 'conta-receber' },
    inactive: { method: 'DELETE', url: 'conta-receber{/id}{/idMov}' },
};